module.exports = __webpack_public_path__ + "media/images/weather/84_day-d73b04b70f8e5341da099c979bb0b16a.png";